import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Analytics } from "@vercel/analytics/react";

// Page components
import LandingPage from './pages/LandingPage';
import RecipeCollection from './pages/RecipeCollection';
import RecipeDetail from './pages/RecipeDetail';
import PublicCollectionView from './pages/PublicCollectionView';
import PublicRecipeDetail from './pages/PublicRecipeDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import Account from './pages/Account';
import PricingPage from './pages/PricingPage';
import CheckoutPage from './pages/CheckoutPage';
import InvitePage from './pages/InvitePage';
import Unsubscribe from './pages/Unsubscribe';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/account" element={<Account />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/invite/:code" element={<InvitePage />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/recipes" element={<RecipeCollection />} />
          <Route path="/recipe/:id" element={<RecipeDetail />} />
          <Route path="/collection/:userId" element={<PublicCollectionView />} />
          <Route path="/share/:userId" element={<PublicCollectionView />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          {/* Username-based routes - supports both username and recipe slug */}
          <Route path="/:username/:recipeSlug" element={<PublicRecipeDetail />} />
          <Route path="/:userId" element={<PublicCollectionView />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Analytics />
    </div>
    </HelmetProvider>
  );
}

export default App;
